import React from "react";
import {Grid, List, ListItem, Stack, styled, Typography} from "@mui/material";
import {THEME_CONFIG} from "../../../config";

const {poll, pollBorder, pollTextColor, borderRadius} = THEME_CONFIG

export default function PhotoPollQuestion({risposte, hideResult = false, answer, sendAnswer, isPoll}) {
    console.log("PhotoPollQuestion > risposte:", risposte)
    const RispostaStyled = styled(ListItem)({
        border: `2px solid ${pollBorder.default}`,
        borderRadius: borderRadius.default,
        background: poll.default,
        margin: '1rem 0',
        cursor: 'pointer',
        color: pollTextColor.default
    })

    const computeBkg = (r, isCorrect) => {
        if(!isPoll && hideResult === false) {
            if (answer !== '') {
                if (isCorrect) {
                    return poll.correct
                } else if (answer === r  && !isCorrect){
                    return poll.wrong
                }
            }
        } else {
            if(answer === r) {
                return poll.answered
            }
        }

    }

    const computeBorderColor = (r, isCorrect) => {
        if(!isPoll && hideResult === false) {
            if (answer !== '') {
                if (isCorrect) {
                    return pollBorder.correct
                } else if (answer === r  && !isCorrect){
                    return pollBorder.wrong
                }
            }
        } else {
            if(answer === r) {
                return pollBorder.answered
            }
        }
    }

    const computeTextColor = (r, isCorrect) => {
        if(!isPoll && hideResult === false) {
            if (answer !== '') {
                if (isCorrect) {
                    return pollTextColor.correct
                } else if (answer === r  && !isCorrect) {
                    return pollTextColor.wrong
                }
            }
        } else {
            if(answer === r) {
                return pollTextColor.answered
            }
        }
    }

    const Risposte = () => (
        risposte.map((r, i) => {
            const isPicturesPoll = !!r?.image?.url
            const isCorrect = r?.isCorrect
            const rispText = r?.label || (typeof r === 'string' ? r : "")
            return <Grid item xs={isPicturesPoll ? 6 : 12}
                  sx={{
                      scale: isPicturesPoll ? answer ? answer === rispText ? '1.05' : '0.9' : '1' : 'inherit',
                      opacity: (isCorrect && !hideResult) ? '1' : isPicturesPoll ? answer ? answer === rispText ? '1' : '0.5' : '1' : 'inherit',
                  }}>
            <RispostaStyled key={i} style={{
                width: '100%',
                background: computeBkg(rispText, isCorrect),
                border: computeBorderColor(rispText, isCorrect) ? '2px solid '+ computeBorderColor(rispText, isCorrect) : `2px solid ${pollBorder.default}`,
                color: computeTextColor(rispText, isCorrect) ?  computeTextColor(rispText, isCorrect) :  pollTextColor.default,
                margin: isPicturesPoll ? 'inherit' : '1rem 0',
            }} onClick={() => rispondi(rispText)}>
                <Stack>
                    {
                        isPicturesPoll &&
                            <img
                                src={r?.image?.url}
                                alt={rispText}
                                style={{
                                    aspectRatio: '1/1',
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                    borderRadius: borderRadius.default,
                                }}/>
                    }
                    {rispText && <Typography sx={{mt: isPicturesPoll ? 1 : 'inherit'}} textAlign={"center"} fontWeight={'bolder'}
                                 variant={isPicturesPoll ? 'body2' : 'h6'}>
                        {rispText}
                    </Typography>}
                </Stack>
            </RispostaStyled>
            </Grid>
        })
    )

    const rispondi = (r) => {
        if (isPoll) {
            sendAnswer(r)
        } else {
            if (answer === '') {

                sendAnswer(r)
            }
        }
    }

    const isPicturesPoll = risposte && risposte[0] && !!risposte[0]?.image?.url
    console.log("PhotoPollQuestion > isPicturesPoll:", isPicturesPoll)

    return (
        <List>
            {isPicturesPoll ?
                <Grid container spacing={1} justifyContent={'center'}>
                    <Risposte/>
                </Grid>
            : <Risposte/>}
        </List>
    )
}
